module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephanie Perry Moore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Stephanie Perry Moore")]), _vm._v(" was born in South Carolina and now lives with her family in Georgia. She is the author of many YA series, including the "), _c('B', [_vm._v("Lockwood Lions")]), _vm._v(", the "), _c('B', [_vm._v("Grovehill Giants")]), _vm._v(", and the"), _c('B', [_vm._v(" Payton Skky")]), _vm._v(" series.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FDZr5i/tc-custom/9781467774475.jpg?1705766093332",
      "alt": "This image is the cover for the book Icing on the Cake, The Sharp Sisters"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Icing on the Cake, The Sharp Sisters\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Sharp sisters are bold, bright, sassy, stylin', and fierce. As the daughters of mayoral candidate Stanley Sharp, all eyes are on them as they attend high school. Every choice they make can make or break their father's campaign—and make or break their own chances for success. ")]), _c('p'), _c('p', [_vm._v("Desperate to measure up to her talented older sisters, Yuri Sharp wants to become a top pastry chef. But while learning the ropes at a local bake shop, Yuri discovers that corners are being cut, and people are getting sick. Speaking up has already landed her on the wrong side of a violent school gang. Will Yuri keep her silence this time, or will she be forced to speak up and accept whatever consequences may come?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Darby Creek\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0